module.exports = __webpack_public_path__ + "img/search-icon.a5082d67.svg";